import styled from 'styled-components';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import { Circle } from 'assets/icons';
import ProductPricing from 'components/products/product_pricing';
import { ctaGreen } from 'constants/variables';

/**
 * Renders a <SimilarStockItemsCarousel/> component
 * @param props
 * @param props.similarStockItems - Array items to be rendered
 * @param props.isProductDetail - Bool to check for product detail page (TODO)
 */

const SimilarStockItemsCarousel = ({
  similarStockItems,
  isProductDetail,
  vatExclusive,
  prices,
  carouselOptions = {},
}) => (
  <Splide
    hasTrack={false}
    className="splide"
    role="group"
    aria-label="product image carousel"
    options={carouselOptions}>
    <div className="splide__track">
      <ul className="splide__list">
        {similarStockItems.map(
          ({ id, description, image, partCode, stockCode, stock, slug }, i) => (
            <SplideSlide
              className={`similar-stock-carousel__item splide__slide splide__slide--${i} p-20`}
              key={id}
              data-testid="splide__slide--similarstock-item">
              <a href={`/catalogue/products/${slug}`} className="d-block">
                <ImageContainer>
                  <img src={image} alt="" width="" height="" />
                </ImageContainer>
                <p
                  className="fw-600 fs-16 ff-body splide__slide--similarstock-description"
                  data-testid="splide__slide--similarstock-description">
                  {description}
                </p>
                {!isProductDetail && (
                  <>
                    <p>Part Code: {partCode}</p>
                    <p>Stock Code: {stockCode}</p>
                  </>
                )}
                <ProductPricing
                  id={id}
                  prices={prices}
                  vatStatus={vatExclusive}
                />
                <p
                  className="fs-14 fl tc-grey-70 ai-c"
                  data-testid="splide__slide--similarstock-stock">
                  <Circle fill={ctaGreen} />
                  <StockSpan>{stock}</StockSpan> in stock
                </p>
                <p className="fs-14 splide__slide--similarstock-product-link">
                  Click here to view this product, you can then add it to your
                  basket.
                </p>
              </a>
            </SplideSlide>
          ),
        )}
      </ul>
    </div>
  </Splide>
);

const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
`;

const StockSpan = styled.span`
  color: #207600;
  margin-left: 3px;
  margin-right: 3px;
  font-weight: 700;
`;

export default SimilarStockItemsCarousel;
